/** Locale-aware formatting helpers on top of `@platform/i18n`'s `formatNumber`. */

type FormatNumber = (value: number, options?: Intl.NumberFormatOptions) => string;

const UNITS = ['byte', 'kilobyte', 'megabyte', 'gigabyte'] as const;

/** 1536 → "1.5 kB" (binary steps of 1024, unit names from Intl). */
export function formatBytes(bytes: number, formatNumber: FormatNumber): string {
  let value = Math.max(0, bytes);
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit++;
  }
  // Intl spells bytes out ("804 byte"); the SI symbol B is language-neutral.
  if (unit === 0) return `${formatNumber(value, { maximumFractionDigits: 0 })} B`;
  return formatNumber(value, { style: 'unit', unit: UNITS[unit], unitDisplay: 'short', maximumFractionDigits: 1 });
}
